import React from 'react'
import { Card, Spinner, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface ContentData {
  title: string
  description: string
  image: {
    url: string
    alt: string
  }
  url: string
}

interface ProfessionalContentHighlightsProps {
  mainContent: ContentData
  contents: ContentData[]
  isLoading: boolean
}

const ProfessionalContentHighlights = ({
  mainContent,
  contents,
  isLoading
}: ProfessionalContentHighlightsProps): JSX.Element => {
  return (
    <S.Container>
      <Card customClassName='ProfessionalContentHighlights__Card' variant='regular'> 
        {isLoading && (
          <S.LoadingWrapper>
            <Spinner />
          </S.LoadingWrapper>
        )}
        {!isLoading && (
          <>
          {mainContent && (
            <S.MainContentWrapper href={mainContent.url} target="_blank">
              <S.MainImage src={mainContent.image.url} alt={mainContent.image.url}/>
              <S.MainContent>
                <Typography variant='content2' weight='bolder'>
                  {mainContent.title}
                </Typography>
                <Typography variant='content2'>
                  {mainContent.description}
                </Typography>
              </S.MainContent>
            </S.MainContentWrapper>
          )}
        <S.ContentsWrapper>
          {contents && contents.map((content, index) => (
            <S.ContentWrapper key={index} href={content.url} target='_blank'>
              <S.ContentImage src={content.image.url} alt={content.image.url}/>
              <S.ContentTextWrapper>
                <Typography variant='content2' weight='bolder'>
                  {content.title}
                </Typography>
                <Typography variant='content2'>
                  {content.description}
                </Typography>
              </S.ContentTextWrapper>
            </S.ContentWrapper>
          ))}
        </S.ContentsWrapper>
        <S.Link href='https://conteudo.telavita.com.br/veja-como-funciona-psi' target='_blank'>
          Confira outros conteúdos
        </S.Link>
          </>
        )}
      </Card>
    </S.Container>
  )
}

export {
  ProfessionalContentHighlights
}